import { useMutation, useQuery, useQueryClient, useInfiniteQuery } from "@tanstack/react-query";
import { sendOtp, superadminLoginApi, superadminVerifyApi, verifyOtp, emailSendOtp, emailVerifyOtp , getProfile, logout} from "@/api/auth.api";
import { addClinicApi, getClinicsApi, updateClinicApi, StatusClinicApi, getClinicByIdApi } from "@/api/superadmin.api";
import { listStaff, addStaff, updateStaff, actionStaff, staffpermlist, showstaffdata, AdmindashboardApi, addPatient, listPatient,updategallery, patientProfile,patientStatus, consentTemplates, patientlist, updatePatient, showPatient, visitTypes, sendCapturePhoto, allphotos, detailphotodata, beforeafter, createMultiPhotoCollage, deleteApi } from "@/api/Admin.api";


// ==================== AUTH HOOKS ====================



export const useLogin = () => {
  return useMutation({
    mutationFn: superadminLoginApi,
    onSuccess: (data) => {
      console.log("Login successful:", data);
    },
    onError: (error) => {
      console.error("Login error:", error);
    },
  });
};

export const usesendotp = () => {
  return useMutation({
    mutationFn: sendOtp,
    onError: (data) => {
      console.error("Send OTP error:", data);
    }
  })
}

export const useVerifyOtp = () => {
  return useMutation({
    mutationFn: verifyOtp,
    onError: (data) => {
      console.error("Verify OTP error:", data);
    }
  })
}

export const useEmailSendOtp = () => {
  return useMutation({
    mutationFn: emailSendOtp,
    onError: (data) => {
      console.error("Send Email OTP error:", data);
    }
  })
}

export const useEmailVerifyOtp = () => {
  return useMutation({
    mutationFn: emailVerifyOtp,
    onError: (data) => {
      console.error("Verify Email OTP error:", data);
    }
  })
}

// Superadmin OTP hooks - uses same API endpoint for both send and verify
export const useSuperadminSendOtp = () => {
  return useMutation({
    mutationFn: superadminLoginApi,
    onError: (data) => {
      console.error("Superadmin Send OTP error:", data);
    }
  })
}

export const useSuperadminVerifyOtp = () => {
  return useMutation({
    mutationFn: superadminVerifyApi,
    onError: (data) => {
      console.error("Superadmin Verify OTP error:", data);
    }
  })
}

export const useLogout = () => {
  return useMutation({
    mutationFn: async () => {
      const response = await logout();
      return response;
    },
    onError: (error) => {
      console.error("Logout error:", error);
    },
  });
};


// ==================== PROFILE HOOKS ====================

export const useGetProfile = () => {
  return useQuery({
    queryKey: ['profile'],
    queryFn: getProfile,
    refetchOnWindowFocus: false,
  });
};

// ====================SUPERADMIN CLINIC HOOKS ====================

// Fetch all clinics
export const useGetClinics = (search = '', page, options = {}) => {
  return useQuery({
    queryKey: ['clinics', search, page],
    queryFn: () => getClinicsApi(search, page),
    refetchOnWindowFocus: true,
    refetchOnMount: false,
    refetchInterval: false,
    staleTime: 5 * 60 * 1000,
    keepPreviousData: true,
    enabled: options.enabled !== false, // Allow disabling the query
    ...options, // Spread other options
  });
};



// Add a new clinic
export const useAddClinic = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addClinicApi,
    onSuccess: () => {
      // Refresh the clinics list after addition
      queryClient.invalidateQueries(['clinics']);
    },
  });
};

// Update a clinic
export const useUpdateClinic = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateClinicApi,
    onSuccess: () => {
      // Refresh the clinics list after update
      queryClient.invalidateQueries(['clinics']);
    },
  });
};

// Delete / Update status of a clinic
export const useStatusClinic = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: StatusClinicApi,
    onSuccess: () => {
     
      queryClient.invalidateQueries({ queryKey: ['clinics'] });
    },
  });
};

// Fetch clinic by ID
export const useGetClinicById = (clinicId, options = {}) => {
  return useQuery({
    queryKey: ['clinic', clinicId],
    queryFn: () => getClinicByIdApi(clinicId),
    enabled: !!clinicId && options.enabled !== false,
    ...options,
  });
};

// =================== ADMIN HOOKS ====================

// staff 

export const useListStaff = (search = '', role, page) => {
  return useQuery({
    queryKey: ['staff', search, role, page],
    queryFn: () => listStaff(search, role, page),
    refetchOnWindowFocus: false,
  });
}

export const useAddStaff = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: addStaff,
    onSuccess: () => {
      queryClient.invalidateQueries(['staff']);
    },
    onError: (error) => {
      console.error("Add staff error:", error);
    }
  })
}

export const useUpdateStaff = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...payload }) => updateStaff(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries(['staff']);
    },
    onError: (error) => {
      console.error("Update staff error:", error);
    }
  })
}



export const useStatusStaff = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: actionStaff,
    onSuccess: () => {
      queryClient.invalidateQueries(['staff']);
    },
    onError: (error) => {
      console.error("Status staff error:", error);
    }
  })
}

export const useStaffPerm = () => {
  return useQuery({
    queryKey: ['staffperm'],
    queryFn: staffpermlist,
    refetchOnWindowFocus: false,

  })
}

export const useShowStaffData = (id, options = {}) => {
  return useQuery({
    queryKey: ['staffdata', id],
    queryFn: () => showstaffdata(id),
    enabled: !!id && options.enabled !== false,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    staleTime: 0,
    ...options,
  });
};


// =================== DASHBOARD HOOKS ====================

export const useAdminDashboard = () => {
  return useQuery({
    queryKey: ['admindashboard'],
    queryFn: AdmindashboardApi,
    refetchOnWindowFocus: false,
    //   refetchOnMount: true,
  });
}

// =================== PATIENT HOOKS ====================

export const useAddPatient = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: addPatient,

    onSuccess: () => {
      queryClient.invalidateQueries(['patients']);

    },
  });
}

export const useListPatient = (search = '', page, from_date, to_date,is_active) => {
  return useQuery({
    queryKey: ['patients', search, page, from_date, to_date,is_active],
    queryFn: () => listPatient(search, page, from_date, to_date,is_active),
    refetchOnWindowFocus: false,
  });
}

export const usePatientProfile = (id, options = {}) => {
  return useQuery({
    queryKey: ['patientprofile', id],
    queryFn: () => patientProfile(id),
    enabled: !!id && options.enabled !== false,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    staleTime: 0,
    ...options,
  });
}

export const useConsentTemplates = () => {
  return useQuery({
    queryKey: ['consenttemplates'],
    queryFn: consentTemplates,
    refetchOnWindowFocus: false,
  });
}

export const useUpdatePatient = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updatePatient,
    onSuccess: () => {
      queryClient.invalidateQueries(['patients']);
    },
  });
};

export const useShowPatient = (id, options = {}) => {
  return useQuery({
    queryKey: ['patient', id],
    queryFn: () => showPatient(id),
    enabled: !!id && options.enabled !== false,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    staleTime: 0,
    ...options,
  });
}


export const useTogglePatientStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => patientStatus(id), 
     onSuccess: () => {
      queryClient.invalidateQueries(['patients']);
    },
  });
};

// *--- Capture Photo Api ---*
export const useVisitTypes = () => {
  return useQuery({
    queryKey: ['visittypes'],
    queryFn: visitTypes,
    refetchOnWindowFocus: false,
  })
}

export const usePatientList = (search = '', options = {}) => {
  const params = {}
  if (search && search.trim()) {
    params.search = search.trim();
  }
  return useQuery({
    queryKey: ['patientlistcapture', search],
    queryFn: () => patientlist(params),
    refetchOnWindowFocus: false,
    ...options, // Allow passing enabled and other options
  })
}

export const useSendCapturePhoto = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ patientId, formData }) => sendCapturePhoto(patientId, formData),
    onSuccess: () => {
      queryClient.invalidateQueries(['capturephoto']);
      queryClient.invalidateQueries(['patientprofile']);
    },
    onError: (error) => {
      console.error("Send capture photo error:", error);
    }
  })
}

// *--- Gallery Api ---*
export const useAllPhotos = (params = {}) => {
  // Build params object for API call
  const apiParams = {};
  if (params.search && params.search.trim()) {
    apiParams.search = params.search.trim();
  }
  if (params.visit_type_id) {
    apiParams.visit_type_id = params.visit_type_id;
  }
  return useInfiniteQuery({
    queryKey: ['allphotos', apiParams],
    queryFn: ({ pageParam = 1 }) =>
      allphotos({ pageParam, params: apiParams }),

    getNextPageParam: (lastPage) => {
      return lastPage?.next_page_url
        ? lastPage.current_page + 1
        : undefined;
    },


    // staleTime: 5 * 60 * 1000,
    keepPreviousData: true,
    refetchOnWindowFocus: true,
  })
}

export const usedetailphotodata = (photoId, patientId) => {
  return useQuery({
    queryKey: ['detailphotodata', photoId, patientId],
    queryFn: () => detailphotodata(photoId, patientId),
    enabled: !!photoId, // Only fetch when photoId exists
    refetchOnMount: true, // Refetch when component mounts (dialog opens)
    refetchOnWindowFocus: false,
  })
}

export const usegalleryUpdate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn:updategallery,
    onSuccess: () => {
      queryClient.invalidateQueries(['detailphotodata']);
     
    }
    
  })
}

// *-- Before After Api --*
export const useBeforeAfter = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: beforeafter,
    onError: (error) => {
      console.error("Before after error:", error);
    }

  })
}

// *-- Collage Api --*
export const useCreateMultiPhotoCollage = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createMultiPhotoCollage,
    onError: (error) => {
      console.error("Create multi photo collage error:", error);
    }
  })
}

// delete api 

export const usedeleteApi = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteApi,
    onSuccess: () => {
      queryClient.invalidateQueries(['patient-profile']);
    },
    onError: (err) => {
      console.error('Delete Api error', err);
    },
  });
};
